import React from 'react'
import { Typography } from '@mui/material'
import { Row, Col, Container } from '@themesberg/react-bootstrap'
import useLivePlayers from '../../hooks/useLivePlayers'
import { SpinnerLoader } from '../../../../../components/Preloader'
import './livePlayer.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDesktop, faMobileAlt, faTabletAlt, faRedo } from '@fortawesome/free-solid-svg-icons'
import { CircleChart } from '../../../../../components/CircleChart'
import { getTextColor } from '../../../../../utils/dashboardEffects'
import DashboardIconBox from '../../StateBox'
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import ContactsIcon from '@mui/icons-material/Contacts'
import LiveTvIcon from '@mui/icons-material/LiveTv'
import AddCardIcon from '@mui/icons-material/AddCard'
import { DashboardHeadTitle, DashboardLiveContainer } from '../../style'
import Highcharts from 'highcharts'
import PieChart from 'highcharts-react-official'
import LiveTvRoundedIcon from '@mui/icons-material/LiveTvRounded'
const dataToCChange = (data) => {
  const options = {
    chart: {
      type: 'pie',
      height: (12.5 / 16 * 100) + '%',
      backgroundColor: {
        linearGradient: [0, 0, 500, 500],
        stops: [
          [0, 'rgb(255, 255, 255)'],
          [1, 'rgb(200, 200, 255)']
        ]
      },
      polar: true,
      events: {
        // render: function () {
        // 	const title = this.title
        // 	title.attr({
        // 	y: this.plotTop + this.plotHeight / 2 +
        // 			title.getBBox().height / 2 -
        // 			parseInt(title.styles.fontSize)
        // 	})
        // }
      }
    },
    responsive: {
      rules: [{
        condition: {
          // maxWidth: 500
        },
        chartOptions: {
          chart: {
            height: 300
          },
          subtitle: {
            text: null
          },
          navigator: {
            enabled: false
          }
        }
      }]
    },
    credits: {
      enabled: false
    },
    tooltip: {
      followPointer: true,
      hideDelay: 100,
      //pointFormat: 'Facilities: {point.y:,.1f} <br>{point.percentage:.1f}%'
      formatter: function () {
        return '<b>' + this.point.name + ': ' + this.y.toLocaleString() + ' players';
      }
    },

    title: {
      text: 'Logged In Players',
      // widthAdjust: -300,
      style: { "fontSize": "12px", fontWeight: 800 },
      align: 'right',
      padding: 10
      //   verticalAlign: 'bottom'
    },
    legend: {
      enabled: true
    },
    plotOptions: {
      pie: {
        size: 200,
        innerSize: '70%',
        dataLabels: {
          enabled: true,
          connectorWidth: 1,
          distance: 25,
          style: {
            color: "contrast",
            fontSize: "11px",
            textOutline: "none", //"1px contrast",
          },
          formatter: function () {
            return this.point.name + ':<br/> ' + this.percentage.toFixed(1) + ' %';
          }
        },
        showInLegend: true
      },
    }
    // plotOptions: {
    //   pie: {
    //     size: 100
    //     // innerSize: 150,
    //     // depth: 10,
    //     // allowPointSelect: true,
    //     // cursor: 'pointer',
    //     // dataLabels: {
    //     //   enabled: true,
    //     //   format: '<b>{point.name}</b>: {point.percentage:.1f} %',
    //     //   connectorColor: 'silver'
    //     // }
    //   }
    // }
  }
  // const filterData = data?.filter(d => d.device_type !== null).map(d => {
  //   return { name: d.device_type, y:Number(d.count), count: Number(d.count) }
  // })

  const filterData = [{ name: 'Logout player', y: data.logoutPlayer, count: data.logoutPlayer }, { name: 'Login Player', y: data.loginPlayer, count: data.loginPlayer }]
  options.series = [
    {
      name: 'Logged In Players',
      data: filterData,
      // data: data,
      showInLegend: true
    }
  ]
  return options
}
export default ({ selectedPortal, selectedClient }) => {
  const {
    loading,
    livePlayerData,
    fetchDetails
  } = useLivePlayers({ selectedPortal, selectedClient })

  const icons = { desktop: faDesktop, mobile: faMobileAlt, tablet: faTabletAlt }
  const color = { desktop: 'secondary', mobile: 'primary', tablet: 'tertiary' }

  console.log('livePlayerData', livePlayerData)

  return (livePlayerData &&
    <DashboardLiveContainer>
      <DashboardHeadTitle>
        {/* <span className='icon-box'>
          <LiveTvRoundedIcon />
        </span> */}
        <h3 className='dashboard-spec-text'>Live Player Report </h3>
        {loading ? <SpinnerLoader /> : <FontAwesomeIcon onClick={() => fetchDetails()} style={{ fontSize: '15px', color: 'gray', cursor: 'pointer', marginLeft: '10px' }} icon={faRedo} />}
        {/* <FontAwesomeIcon onClick={() => fetchDetails()} style={{ fontSize: '15px', color: 'gray', cursor: 'pointer', marginLeft: '10px' }} icon={faRedo} /> */}
      </DashboardHeadTitle>
      <Row className='align-items-center justify-content-center'>


        {/* <Typography variant='h6' className='chart-container-text'>Logged In Players</Typography> */}
        {/* <PieChart
                  highcharts={Highcharts} 
                  options={dataToCChange({
                    logoutPlayer: livePlayerData.totalPlayers - livePlayerData?.loggedInPlayer,
                    loginPlayer: livePlayerData?.loggedInPlayer
                  })}
                /> */}


        <Col xl={12}>
          <Row>
            <Col lg={3}>
              <DashboardIconBox
                bgColor='linear-gradient(100.66deg, rgb(67, 67, 67) 6.56%, rgb(0, 0, 0) 93.57%)'
                icon={<CurrencyExchangeIcon />}
                iconColor='rgb(30 30 30)'
                title='Total Win amount'
                count={`${livePlayerData.totalWinAmount || 0}`}
              //footerText='compared to previous month'
              />
            </Col>
            <Col lg={3}>
              <DashboardIconBox
                title='TOTAL PLAYERS'
                count={livePlayerData.totalPlayers}
                bgColor='linear-gradient(-20deg, rgb(43, 88, 118) 0%, rgb(78, 67, 118) 100%)'
                icon={<PersonAddIcon />}
                iconColor='rgb(54 67 119)'
                playerBalanceData={{
                  cash: {
                    title: "Active Players",
                    amount: livePlayerData?.totalActivePlayers || 0,
                  },
                  nonCash: {
                    title: "InActive Players",
                    amount: livePlayerData?.totalInactivePlayers || 0,
                  },
                }}
                decimal={0}
              // footerText='decrease in orders amounts'
              />
            </Col>
            {/* <Col lg={3}>
              <DashboardIconBox
                title='REGISTRATION CONV. RATE'
                count={`${livePlayerData.registrationConvRate || 0}`}
                symbol={'%'}
                bgColor='linear-gradient(rgb(0, 176, 155), rgb(150, 201, 61))'
                icon={<ContactsIcon />}
                iconColor='rgb(102 182 135)'
               // footerText='compared to previous month'
              />
            </Col> */}

            <Col lg={3}>
              <DashboardIconBox
                title='Total Bet Amount'
                count={`${livePlayerData.totalBetAmount || 0}`}
                symbol={''}
                bgColor='linear-gradient(rgb(0, 176, 155), rgb(150, 201, 61))'
                icon={<ContactsIcon />}
                iconColor='rgb(102 182 135)'
              // footerText='compared to previous month'
              />
            </Col>


            <Col lg={3}>
              <DashboardIconBox
                title='Total Player Balance'
                count={`${livePlayerData.totalPlayerAmount || 0}`}
                bgColor='linear-gradient(135deg, rgb(171, 220, 255) 0%, rgb(3, 150, 255) 100%)'
                icon={<AddCardIcon />}
                iconColor='rgb(87 177 255)'
                isPlayerBalance={true}
                playerBalanceData={{
                  cash: {
                    title: "Cash Balance",
                    amount: livePlayerData?.totalPlayerCashAmount || 0,
                  },
                  nonCash: {
                    title: "Non Cash Balance",
                    amount: livePlayerData?.totalPlayerNonCashAmount || 0,
                  },
                }}


              />
            </Col>
          </Row>
        </Col>

      </Row>

      {/* <Row className='d-none'>
        <Col lg={3}>
          <DashboardIconBox
            title='TODAY GGR'
            count={`€ ${livePlayerData.todayTotalGgr || 0}`}
            bgColor='linear-gradient(100.66deg, rgb(67, 67, 67) 6.56%, rgb(0, 0, 0) 93.57%)'
            icon={<CurrencyExchangeIcon />}
            iconColor='rgb(30 30 30)'
            footerText='compared to previous month'
          />
        </Col>
        <Col lg={3}>
          <DashboardIconBox
            title='TOTAL PLAYERS'
            count={livePlayerData.totalPlayers}
            bgColor='linear-gradient(-20deg, rgb(43, 88, 118) 0%, rgb(78, 67, 118) 100%)'
            icon={<PersonAddIcon />}
            iconColor='rgb(54 67 119)'
            footerText='decrease in orders amounts'
          />
        </Col>
        <Col lg={3}>
          <DashboardIconBox
            title='REGISTRATION CONV. RATE'
            count={`${livePlayerData.registrationConvRate || 0} %`}
            bgColor='linear-gradient(rgb(0, 176, 155), rgb(150, 201, 61))'
            icon={<ContactsIcon />}
            iconColor='rgb(102 182 135)'
            footerText='compared to previous month'
          />
        </Col>
        <Col lg={3}>
          <DashboardIconBox
            title='DEPOSIT CONV. RATE'
            count={`${livePlayerData.depositConvRate || 0} %`}
            bgColor='linear-gradient(135deg, rgb(171, 220, 255) 0%, rgb(3, 150, 255) 100%)'
            icon={<AddCardIcon />}
            iconColor='rgb(87 177 255)'
            footerText='decrease in orders amounts'
          />
        </Col> */}
      {/* </Row>
			</Card>
		</Col> */}
      {/* <Col style={{ maxWidth: '300px' }}>
				<Card className='p-2 mb-2 graph-container'>
				<Row className='d-block d-xl-flex align-items-center'>
					<Col xs={12} xl={5} className='px-xl-0 text-center'>
					<h3 className='green-text'>{livePlayerData?.loggedInPlayer || 0} </h3>
					<p className='gray-text'>Logged In Players</p>
					<CircleChart series={livePlayerData?.deviceLoggedIn.filter(d => d.device_type !== null).map(d => d.count) || []} />
					</Col>
					<Col xs={12} xl={7} className='px-xl-0 text-center'>

					{livePlayerData?.deviceLoggedIn.filter(d => d.device_type !== null).map(d => (
						<p key={`circle-element-${d.device_type}`} className='text-gray device-report'>
						<FontAwesomeIcon icon={icons[d.device_type]} className={`icon icon-xs text-${color[d.device_type]} w-20 me-1`} />
						{` ${d.device_type} `}{`${d.count}`}
						</p>
					))}
					</Col>
				</Row>
				</Card>
			</Col>
			</Row> */}
      {/* </Row> */}
    </DashboardLiveContainer>

  )
}
